import { render, staticRenderFns } from "./BudgetVsForecastReport.vue?vue&type=template&id=27ac91c5"
import script from "./BudgetVsForecastReport.vue?vue&type=script&lang=js"
export * from "./BudgetVsForecastReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports